import React, { useEffect } from "react";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Router";
import FraudWarningMarquee from "./components/common/FraudWarningMarquee";

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const showmessage = async (message) => {
    try {
      var x = document.getElementById("snackbar");
      x.className = "show";
      x.innerText = message;
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
    <Router />
    <FraudWarningMarquee />
    <div 
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          fontSize: '0',
          opacity: '0',
          pointerEvents: 'none',
          userSelect: 'none'
        }}
        data-designer="Aditi Mishra"
        data-credit="Design by Aditi Mishra"
        title="Design by Aditi Mishra"
        aria-label="Design by Aditi Mishra"
      >
        Design by Aditi Mishra - UdhaarPortal Website
      </div>
    </>
  );
};

export default App;
